module.exports = __webpack_public_path__ + "static/media/IMG_4595.d7165141.JPG";